import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=b6bc41a6&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=b6bc41a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bc41a6",
  null
  
)

export default component.exports